import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose, Type } from 'class-transformer';

export class SilStatus extends AdditionalInfoImpl {

  @Expose({ name: 'agid' })
  agid: number;

  @Expose({ name: 'app_version' })
  appVersion: string;

  @Expose({ name: 'busstop_code' })
  busStopCode: string;

  @Expose({ name: 'busstop_distance' })
  busStopDistance: number;

  @Expose({ name: 'busstop_distance_approximation' })
  busStopDistanceApproximation: number;

  @Expose({ name: 'busstop_name' })
  busStopName: string;

  @Expose({ name: 'busstop_timetable' })
  busStopTimetable: string;

  @Expose({ name: 'busstop_type' })
  busStopType: number;

  @Expose({ name: 'busstop_zone' })
  busStopZone: string;

  @Expose({ name: 'course' })
  course: number;

  @Expose({ name: 'course_distance' })
  courseDistance: number;

  @Expose({ name: 'course_time' })
  courseTime: string;

  @Expose({ name: 'door_permission' })
  doorPermission: boolean;

  @Expose({ name: 'doors' })
  doors: boolean;

  @Expose({ name: 'gps_busstop_zone' })
  gpsBusStopZone: boolean;

  @Expose({ name: 'gps_distance' })
  gpsDistance: number;

  @Expose({ name: 'lefttime' })
  leftTime: number;

  @Expose({ name: 'line' })
  line: string;

  @Expose({ name: 'mileage' })
  milage: number;

  @Expose({ name: 'people_count' })
  peopleCount: number;

  @Expose({ name: 'people_enter' })
  peopleEnter: number;

  @Expose({ name: 'people_exit' })
  peopleExit: number;

  @Expose({ name: 'route_code' })
  routeCode: string;

  @Expose({ name: 'route_id' })
  routeId: string;

  @Expose({ name: 'team' })
  team: string;

  @Expose({ name: 'temperature' })
  temperature: number;

  @Expose({ name: 'time' })
  @Type(() => Date)
  time: Date;

  @Expose({ name: 'typeofday' })
  typeOfDay: string;

  @Expose({ name: 'user_id' })
  userId: string;

  @Expose({ name: 'user_name' })
  userName: string;

  @Expose({ name: 'vehicle_id' })
  vehicleIdInner: string;

  @Expose({ name: 'version' })
  version: string;

  @Expose({ name: 'people_enter_tall' })
  peopleEnterTall: number;

  @Expose({ name: 'people_exit_tall' })
  peopleExitTall: number;

  @Expose({ name: 'people_enter_short' })
  peopleEnterShort: number;

  @Expose({ name: 'people_exit_short' })
  peopleExitShort: number;

  @Expose({ name: 'people_enter_door' })
  peopleEnterDoor: string;

  @Expose({ name: 'people_exit_door' })
  peopleExitDoor: string;

}
